import React, { ComponentProps } from 'react';
import cn from 'classnames';
import { Text } from 'wix-ui-tpa/cssVars';
import { classes } from './styles.st.css';

export const TextComponent = (props: ComponentProps<typeof Text>) => (
  <Text {...props} className={cn(classes.text, props.className)} />
);
